// Icons.js
export const PeaceBusinessIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="#FF9810" strokeWidth="2" />
    <path d="M6 12h12" stroke="#FF9810" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 6v12" stroke="#FF9810" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const DelhiNCRIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="#FF9810" strokeWidth="2" />
    <path d="M4 12h16" stroke="#FF9810" strokeWidth="2" />
  </svg>
);

export const EconomicPowerIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
    <rect x="6" y="6" width="12" height="12" stroke="#FF9810" strokeWidth="2" />
    <path d="M6 12h12" stroke="#FF9810" strokeWidth="2" />
  </svg>
);

export const SingleWindowIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
    <rect x="4" y="4" width="16" height="16" stroke="#FF9810" strokeWidth="2" />
    <path d="M4 12h16" stroke="#FF9810" strokeWidth="2" />
  </svg>
);

export const IndustrialInfraIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
    <path
      d="M4 20V4h4v16H4zM10 20V10h4v10h-4zM16 20V14h4v6h-4z"
      stroke="#FF9810"
      strokeWidth="2"
    />
  </svg>
);

export const SkilledWorkforceIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="8" r="3" stroke="#FF9810" strokeWidth="2" />
    <path d="M5 20c0-4 14-4 14 0" stroke="#FF9810" strokeWidth="2" />
  </svg>
);

export const InvestorFriendlyIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2l4 8h-8l4-8zM6 12h12v10H6V12z"
      stroke="#FF9810"
      strokeWidth="2"
    />
  </svg>
);

export const SpiritualCapitalIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="#FF9810" strokeWidth="2" />
    <path d="M12 2v20M2 12h20" stroke="#FF9810" strokeWidth="2" />
  </svg>
);
